<template>
  <div class="main-conent main-conent-maxheight main-content-rows">
    <div class="main-content-cols">
      <side-menu
        v-if="metes.length > 1"
        :menus="menus"
        :loading="loading"
        :actived="actived"
        @change="deviceChange"
      ></side-menu>

      <div class="main-content-cols__body">
        <guaue :loading="loading"></guaue>
        <carousel :loading="loading" :data="curData"></carousel>

        <search
          @date-change="dateChange"
          @type-change="typeChange"
          @export="exportExcel"
        ></search>

        <el-row v-show="type === 'data'" :gutter="20">
          <el-col>
            <data-list
              v-if="reload"
              v-loading="loading"
              ref="table"
              :cols="cols"
              :data="list"
              :height="height"
            ></data-list>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import SideMenu from '@/components/MainSideMenu'
import Carousel from './components/list'
import Search from './components/search'
import DataList from './components/dataList'
import Guaue from './components/guaue'

import { list, cols } from '@/service/meteorology'
import { getIcon } from '@/utlis/meteorology'
import sleep from '@/utlis/sleep'

export default {
  components: { SideMenu, Carousel, Search, DataList, Guaue },
  data() {
    return {
      prevLoading: false, // 初始化列数据
      loading: false,
      loadingCols: false,
      reload: true, // 用于刷新 el-table 高度
      type: 'data', // 显示的类型
      menus: [],
      actived: 0,
      query: {
        begin: moment().format('YYYY-MM-DD 00:00:00'),
        end: moment().format('YYYY-MM-DD 23:59:59')
      },
      cols: [],
      curData: [],
      list: [],
      height: 600
    }
  },
  computed: {
    deviceId() {
      if (!this.metes.length) return 0
      let device = this.metes[this.actived]
      return device && device.id
    },
    listCols() {
      return this.cols.filter(c => c.alias)
    }
  },
  async mounted() {
    this.height = this.$el.offsetHeight - 340
    this.menus = this.metes.map(m => ({ title: m.name }))

    this.loading = true
    await this.getCols()
    await this.initData()

    this.loading = false
  },
  methods: {
    async getCols() {
      const [{ data }] = await Promise.all([cols(this.deviceId), sleep(1)])
      this.cols = data
    },
    async initData() {
      const { begin, end, type } = this.query
      const [oriData, curData] = await Promise.all([
        this.getData(begin, end, type),
        this.getCurData(),
        sleep(1)
      ])

      this.curData = curData
      this.list = oriData
    },
    async getData(begin, end, type = 'day') {
      const { data } = await list({
        companyId: this.companyId,
        deviceId: this.deviceId,
        begin,
        end,
        type
      })

      return data
    },
    async getCurData() {
      const { data } = await list({
        companyId: this.companyId,
        deviceId: this.deviceId,
        type: 'last'
      })
      return this.cols.map(c => {
        let icon = getIcon(c.name)
        return {
          ...c,
          icon: icon.icon,
          color: icon.color,
          value: data[c.key] || '-'
        }
      })
    },
    async dateChange(begin, end, type) {
      this.loading = true
      const data = await this.getData(begin, end, type)
      this.list = data
      this.query = { begin, end, type }
      this.loading = false
    },

    async deviceChange(idx) {
      this.actived = idx
      this.loading = true
      await this.getCols()
      await this.initData()
      this.loading = false
    },
    typeChange(type) {
      this.type = type
    },
    exportExcel(title) {
      this.$refs.table.exportExcel(title)
    }
  }
}
</script>

<style lang="css" scoped>
.main-content-rows .el-row {
  margin-bottom: 0;
}
</style>
